import React, { useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import PropTypes from 'prop-types';
import { useLocation } from '@reach/router';

import SEO from './SEO';
import Header from './Header';
import Footer from './Footer';
import CtaWhatapp from './CtaWhatapp';

import esMessages from '../locales/es.js';
import enMessages from '../locales/en.js';

import config from '../constants/site-config';

// Styles
import '../assets/styles/main.scss';

const messages = {
  es: esMessages,
  en: enMessages,
};

const Layout = ({ children, title, description, metaImage, location }) => {
  // ININITALIZE GOOGLE OPTIMIZE EXPERIMENT ON 'optimize.activate'
  // useEffect(() => {
  //   window.dataLayer = window.dataLayer || [];
  //   window.dataLayer.push({ event: 'optimize.activate' });
  // }, []);
  const path_splits = location.pathname.split('/');
  let locale = config.defaultLang;
  const incipit = path_splits[1];
  if (config.locales.indexOf(incipit) > -1) {
    locale = incipit;
  }

  useEffect(() => {
    if (location?.search?.includes('ref=google-ads')) {
      window.userFromGoogleAds = true;
    }
    if (location?.search?.includes('ref=facebook-ads')) {
      window.userFromFacebookAds = true;
    }
    if (location?.search?.includes('ref=gooverseas')) {
      window.userFromGoOverseas = true;
    }
    if (location?.search?.includes('ref=goabroad')) {
      window.userFromGoAbroad = true;
    }
  }, []);

  return (
    <IntlProvider locale={locale} messages={messages[locale]}>
      <SEO
        locale={locale}
        location={location}
        title={title}
        description={description}
        url={location.href}
        metaImage={metaImage}
      />

      <Header locale={locale} location={location} />
      <div>{children}</div>
      <Footer />
    </IntlProvider>
  );
};

const WithLocationLayout = (props) => {
  const location = useLocation();
  return <Layout {...props} location={location} />;
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default WithLocationLayout;
